import { Col, Row } from 'react-bootstrap';
import { Breadcrumb } from '../../../components/Breadcrumb';
import { Report } from '../../../components/Report';

export const ReportInfluencer = () => (
  <div>
    <Breadcrumb
      items={[
        {
          title: 'Influenciadores',
          link: '/influencers',
        },
        {
          title: 'Relatório',
        },
      ]}
    />

    <Row className="d-flex align-items-center mt-4">
      <Col md={10} xs={8}>
        <h4>Relatório do Influenciador</h4>
      </Col>
    </Row>

    <Report route="influencers" />
  </div>
);
